module.exports = __webpack_public_path__ + "static/media/apartment1.ad5bc540.jpg";